import React, { useState, useEffect } from "react";
import "./Slideshow.css";

const Slideshow = () => {
  const images = [
    "images/slider1.png",
    "images/slider2.png",
    "images/slider3.png",
    "images/slider5.png",
    "images/slider6.png",
    "images/slider7.png",
    "images/slider8.png",
    "images/slider9.png",
    "images/slider10.png",
    "images/slider11.png",
    "images/slider12.png",
    "images/slider13.png",
    "images/slider14.png",
    "images/slider15.png"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000); // Change slide every 3 seconds
      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [images.length, isPaused]);

  const handlePause = () => {
    setIsPaused(!isPaused); // Toggle pause state
  };

  return (
    <div className="slider-container w-[600px] h-[100px] ">
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex}`}
        className="slider-image "
      />
      <button className="slider-button" onClick={handlePause}>
        {isPaused ? "Resume" : "Pause"}
      </button>
    </div>
  );
};

export default Slideshow;